import styled from 'styled-components'
import { colors, fontSizes } from '../../../styles/theme'

const Muted = styled.span`
  color: ${colors.neutral500};
  font-size: ${fontSizes.size600};
`

export default Muted
